import { Outlet } from 'react-router-dom'
import { motion } from 'framer-motion'
import Header from './Header'
import Footer from './Footer'
import SquiblaSlot from '@/components/ads/SquiblaSlot'

// MainLayout — editorial frame (Aug 2026 redesign).
//
// OLD: 3-column [Sidebar | Main | RightSidebar] — sidebar-heavy, glass cards.
// NEW: 2-zone [Header bar / Main + Footer] — newspaper style. The home page
// has its own sticky right rail inside Main, so we don't need a global one.
//
// AD SHELL: header_banner + footer_banner slots are real SquiblaSlot
// components. They fetch live ad HTML on mount and replace their placeholder
// text. This is the entire revenue model — these slots must never be empty.
export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <Header />

      {/* Header banner ad slot — real Squibla slot */}
      <div className="max-w-7xl mx-auto w-full px-4 pt-3">
        <SquiblaSlot slot="header_banner" alwaysLabel />
      </div>

      {/* Main content — single column, the page itself manages its layout */}
      <motion.main
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
        className="flex-1 max-w-7xl mx-auto w-full px-4 pt-3 pb-6"
      >
        <Outlet />
      </motion.main>

      {/* Footer banner ad slot — real Squibla slot */}
      <div className="max-w-7xl mx-auto w-full px-4">
        <SquiblaSlot slot="footer_banner" alwaysLabel />
      </div>

      <Footer />

      {/* Sticky bottom mobile banner — high-CTR placement. Hidden on lg+
          because the sidebar/footer banners already cover desktop inventory. */}
      <div
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-2 border-t"
        style={{ backgroundColor: "var(--bg-primary)", borderColor: "var(--rule)" }}
      >
        <SquiblaSlot slot="footer_banner" />
      </div>
    </div>
  )
}
